var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWinnerBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 352.903,
    height: 68.281,
    viewBox: "0 0 352.903 68.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_135408",
    "data-name": "Path 135408",
    d: "M0,0,16.153,34.959,0,68.281H352.9L336.75,34.959,352.9,0Z",
    transform: "translate(0 0)",
    fill: "#fff8f3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinnerBadge);
export default __webpack_public_path__ + "static/media/winnerBadge.48e5be19195fed8f7f878ede80703c1b.svg";
export { ForwardRef as ReactComponent };